import { useState } from "react";
import {appRoutes} from "../../Routes";
import {SideBar} from "./SideBar";
import { useEntitlements } from "../../EntitlementProvider";

export interface PageProps {
    className?: string,
    children?
}

export const Page = ({children, className}: PageProps) => {
    const entitlement = useEntitlements()
    const [collapsed, setCollapsed] = useState<boolean>(() => {
        return localStorage.getItem('sidebar-collapsed') === 'true'
    })

    const handleToggleCollapse = (): void => {
        setCollapsed(prev => {
            const next = !prev
            localStorage.setItem('sidebar-collapsed', String(next))
            return next
        })
    }

    return <div className={`app ${collapsed ? 'app--sidebar-collapsed' : ''}`}>
        <div data-testid={'sideBarContainer'} className={'sideBarContainer'}>
            <SideBar
                routes={appRoutes.filter(route => entitlement.can(route))}
                collapsed={collapsed}
                onToggleCollapse={handleToggleCollapse}
            />
        </div>
        <div className={`container ${className}`}>
            {children}
        </div>
    </div>
}